import { render, staticRenderFns } from "./MainHeader.vue?vue&type=template&id=a21c4ccc&scoped=true"
import script from "./MainHeader.vue?vue&type=script&lang=js"
export * from "./MainHeader.vue?vue&type=script&lang=js"
import style0 from "./MainHeader.vue?vue&type=style&index=0&id=a21c4ccc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21c4ccc",
  null
  
)

export default component.exports